<template>
  <v-layout wrap justify-center align-center>
    <v-flex xs12>
      <v-card :width="300">
        <v-list two-line class="others-fields">
          <v-subheader style="color: black;"> {{title}} </v-subheader>
          <v-divider :inset="false"></v-divider>
          <template v-for="(item, index) in items">
            <!-- click utilizado para formatação do campo -->
            <v-list-tile :key="index" @click="">
              <v-list-tile-content>
                <v-list-tile-sub-title v-html="item.subtitle"></v-list-tile-sub-title>
                <v-divider :inset="false"></v-divider>
              </v-list-tile-content>
            </v-list-tile>
          </template>
        </v-list>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
  import moment from 'moment'
  import momentDurationFormatSetup from 'moment-duration-format'

  momentDurationFormatSetup(moment)
  export default {
    name: 'POtherField',
    props: {
      othersFields: Array,
      reload: false,
      title: {
        type: String,
        default: 'Outros campos'
      }
    },
    data: () => ({
      items: []
    }),
    mounted () {
      this.items = this.otherFields()
    },
    watch: {
      othersFields (val) {
        this.items = this.otherFields()
      }
    },
    methods: {
      otherFields () {
        let data = []
        this.othersFields.map(function (currentValue, index, arr) {
          data.push({
            subtitle: '<span class=\'text--primary\'>' + currentValue.field + ': </span>' + this.getIdText(currentValue.value)
          })
        }, this)
        return data
      },
      getDateText (text) {
        let result
        if (text.length < 12) {
          result = moment(text).format('DD/MM/YYYY')
        } else {
          result = moment(text).format('DD/MM/YYYY - HH:mm:ss')
        }
        return result
      },
      getIdText (text) {
        let result
        if (text == null) {
          result = ''
        } else if (typeof text === 'boolean') {
          result = text ? 'Sim' : 'Não'
        } else if (typeof text === 'number') {
          result = text
          // foi inserido o text.length pois toda data é maior que 9 pra não dar problemas quando vier um numero que devia ser string
        } else if ((text.length > 9) && (moment(text, 'YYYY-MM-DD', true).isValid() || moment(text, 'YYYY-MM-DD HH:mm:ss', true).isValid())) {
          result = this.getDateText(text)
        } else {
          result = text
        }
        return result
      }
    }
  }
</script>

<style>
  .others-fields a {
    height: 25px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/shared/POtherField.vue